(() => {
  'use strict';

  // This cart exists only in the local design preview; Shopify never loads its markup.
  const previewForm = document.querySelector('[data-purchase-form][data-preview]');
  const previewDialog = previewForm && document.querySelector('.cart-dialog');
  let previewQuantity = 0;
  if (previewDialog) {
    try {
      const saved = Number(sessionStorage.getItem('gluf-preview-quantity'));
      if (Number.isSafeInteger(saved) && saved > 0) previewQuantity = saved;
    } catch { /* The demo still works when browser storage is disabled. */ }
    const quantity = previewDialog.querySelector('#cart-quantity-preview');
    previewDialog.querySelector('[data-cart-minus]').addEventListener('click', () => {
      if (previewQuantity > 1) previewQuantity--;
      renderPreviewCart();
    });
    previewDialog.querySelector('[data-cart-plus]').addEventListener('click', () => {
      previewQuantity++;
      renderPreviewCart();
    });
    previewDialog.querySelector('[data-cart-remove]').addEventListener('click', () => {
      previewQuantity = 0;
      renderPreviewCart();
      previewDialog.querySelector('[data-close-cart]').focus();
    });
    quantity.addEventListener('change', () => {
      if (!quantity.reportValidity()) return;
      previewQuantity = quantity.valueAsNumber;
      renderPreviewCart();
    });
    renderPreviewCart();
  }

  function renderPreviewCart() {
    previewDialog.querySelector('.cart-empty').hidden = previewQuantity > 0;
    previewDialog.querySelector('.preview-cart-filled').hidden = previewQuantity === 0;
    previewDialog.querySelector('[data-preview-count]').textContent = `[ ${previewQuantity} ]`;
    previewDialog.querySelector('#cart-quantity-preview').value = previewQuantity || 1;
    previewDialog.querySelector('[data-cart-minus]').disabled = previewQuantity <= 1;
    document.querySelector('.cart-count').textContent = previewQuantity;
    document.querySelector('.cart-toggle').setAttribute('aria-label', `Abrir bolsa, ${previewQuantity} productos`);
    try { sessionStorage.setItem('gluf-preview-quantity', String(previewQuantity)); } catch { /* Optional demo persistence. */ }
  }

  function initPurchases(root = document) {
    root.querySelectorAll('[data-purchase-form]').forEach(form => {
      if (form.dataset.purchaseReady) return;
      form.dataset.purchaseReady = 'true';
      const variantInput = form.elements.namedItem('id');
      const quantity = form.elements.namedItem('quantity');
      const add = form.querySelector('[data-add-button]');
      const minus = form.querySelector('[data-quantity-minus]');
      const plus = form.querySelector('[data-quantity-plus]');
      const error = form.querySelector('[data-purchase-error]');
      const cartLink = form.querySelector('[data-purchase-cart-link]');
      let pending = false;
      const selected = () => variantInput.selectedOptions?.[0] || variantInput;
      const clearError = () => {
        error.textContent = '';
        error.hidden = true;
        if (cartLink) cartLink.hidden = true;
      };
      function syncControls() {
        const available = selected().dataset.available === 'true';
        add.disabled = pending || !available;
        add.textContent = pending ? '[ AÑADIENDO… ]' : available ? '[ AÑADIR A LA BOLSA ]' : '[ AGOTADO ]';
        minus.disabled = pending || !available || quantity.valueAsNumber <= Number(quantity.min);
        plus.disabled = pending || !available || (!!quantity.max && quantity.valueAsNumber + Number(quantity.step) > Number(quantity.max));
        quantity.disabled = pending || !available;
        variantInput.disabled = pending;
      }
      function syncVariant() {
        const option = selected();
        const price = form.querySelector('[data-variant-price]');
        if (price && option.dataset.price) price.textContent = option.dataset.price;
        const compare = form.querySelector('[data-compare-price]');
        if (compare && option.dataset.sale) {
          compare.hidden = option.dataset.sale !== 'true';
          form.querySelector('[data-compare-value]').textContent = option.dataset.compare;
        }
        quantity.min = option.dataset.min || '1';
        quantity.step = option.dataset.step || '1';
        if (option.dataset.max) quantity.max = option.dataset.max;
        else quantity.removeAttribute('max');
        quantity.disabled = false;
        if (!quantity.checkValidity()) quantity.value = quantity.min;
        const availability = form.querySelector('[data-availability-label]');
        if (availability) availability.textContent = option.dataset.available === 'true' ? 'Disponible' : 'Agotado';
        form.querySelector('[data-purchase-availability]')?.classList.toggle('is-sold-out', option.dataset.available !== 'true');
        clearError();
        syncControls();
      }
      variantInput.addEventListener('change', syncVariant);
      quantity.addEventListener('input', syncControls);
      minus.addEventListener('click', () => { quantity.stepDown(); syncControls(); });
      plus.addEventListener('click', () => { quantity.stepUp(); syncControls(); });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (pending || selected().dataset.available !== 'true' || !form.reportValidity()) return;
        clearError();
        if (form.hasAttribute('data-preview')) {
          if (!previewDialog) return;
          previewQuantity += quantity.valueAsNumber;
          renderPreviewCart();
          previewDialog.showModal();
          document.body.classList.add('locked');
          return;
        }
        // Capture before disabling controls. The native form remains usable without JS.
        const body = new FormData(form);
        body.delete('return_to');
        pending = true;
        form.setAttribute('aria-busy', 'true');
        syncControls();
        let navigating = false;
        try {
          // form.action is Shopify's locale-aware cart/add route.
          const endpoint = new URL(form.action);
          endpoint.pathname = endpoint.pathname.replace(/\/$/, '') + '.js';
          const response = await fetch(endpoint, { method: 'POST', body, headers: { Accept: 'application/json' } });
          const result = await response.json();
          if (!response.ok || result.status >= 400) {
            // Shopify may add some available units on a 422: always offer the cart.
            throw new Error(typeof result.description === 'string' ? result.description : 'No se ha podido añadir la cantidad solicitada. Revisa tu bolsa e inténtalo de nuevo.');
          }
          window.location.assign(form.dataset.cartUrl);
          navigating = true;
        } catch (cause) {
          error.textContent = cause instanceof TypeError || cause instanceof SyntaxError
            ? 'No hemos podido confirmar la operación. Revisa tu bolsa antes de volver a añadir el producto.'
            : cause.message;
          error.hidden = false;
          if (cartLink) cartLink.hidden = false;
        } finally {
          if (!navigating) {
            pending = false;
            form.removeAttribute('aria-busy');
            syncControls();
          }
        }
      });
      // Restoring a page from the browser's back/forward cache must unlock the form.
      window.addEventListener('pageshow', () => {
        pending = false;
        form.removeAttribute('aria-busy');
        syncVariant();
      });
      syncVariant();
    });
  }
  initPurchases();
  document.addEventListener('shopify:section:load', event => initPurchases(event.target));
})();
